import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 4 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0.551623 7.8965L3.90264 4.25683C4.03245 4.11583 4.03245 3.88417 3.90264 3.74316L0.551623 0.103501C0.346279 -0.119533 -3.47868e-07 0.0416965 -3.33941e-07 0.360329L-1.57508e-08 7.63966C-1.82258e-09 7.9583 0.34628 8.11953 0.551623 7.8965Z",
      fill: "#EBEBEB"
    }, null, -1)
  ]))]))
}
export default { render: render }